import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Spinner from 'react-spinkit';
import classnames from 'classnames';

import './spinner_wrapper.scss';

const SpinnerWrapper = WrappedComponent => {
  class WithSpinner extends Component {
    constructor(props) {
      super(props);
      this.state = { loading: this.props.shouldFetch ? 'loading' : 'done' };
    }

    componentDidMount() {
      if (this.state.loading === 'loading') {
        WrappedComponent.loadComponent(this.props);
      }
    }

    componentWillReceiveProps(nextProps) {
      if (this.state.loading !== 'done' && WrappedComponent.hasLoaded(nextProps)) {
        this.setState({ loading: 'done' });
      }
    }

    render() {
      if (this.state.loading === 'done') {
        return <WrappedComponent {...this.props} />;
      }

      if (this.state.loading === 'preload' || this.state.loading === 'loading') {
        return (
          <Spinner
            className={classnames('bw-wrapped-spinner', this.props.spinnerClass)}
            fadeIn="none"
            name="three-bounce"
          />
        );
      }

      return null;
    }
  }

  WithSpinner.propTypes = {
    shouldFetch: PropTypes.bool,
    spinnerClass: PropTypes.string,
  };

  WithSpinner.defaultProps = {
    shouldFetch: true,
  };

  return WithSpinner;
};

export default SpinnerWrapper;
